"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/spin/style");
var _spin = _interopRequireDefault(require("antd/lib/spin"));
var _react = _interopRequireDefault(require("react"));
var _components = require("../../../components");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var JoinChannel = function JoinChannel(_ref) {
  var _channel$data;
  var channel = _ref.channel,
    joinChat = _ref.joinChat,
    joiningChat = _ref.joiningChat;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "join-channel flex flex-col justify-evenly items-center md:flex-row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex flex-col justify-center"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "font-semibold mb-[1em]"
  }, "You\u2019re reading #", (_channel$data = channel.data) === null || _channel$data === void 0 ? void 0 : _channel$data.name), /*#__PURE__*/_react.default.createElement("p", {
    className: "mb-[1em]"
  }, "To Comment or post, join the channel")), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_spin.default, {
    spinning: joiningChat
  }, /*#__PURE__*/_react.default.createElement(_components.PrimaryButton, {
    size: "large",
    className: "px-[82px]",
    onClick: joinChat
  }, "Join"))));
};
var _default = JoinChannel;
exports.default = _default;